import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { FormikFormGroup } from "components/common";
const DEFAULT_HIGH_WATERMARK = 95;
const ArchiveBackendFSFieldGroup = () => {
  const { t } = useTranslation("enterprise_archive");
  const {
    values: { id, settings },
    setFieldValue
  } = useFormikContext();
  const highWatermark = settings.high_watermark;
  useEffect(() => {
    if (!id && highWatermark === void 0) {
      setFieldValue("settings.high_watermark", DEFAULT_HIGH_WATERMARK);
    }
  }, [id, highWatermark, setFieldValue]);
  return /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.high_watermark",
      type: "number",
      min: 1,
      max: 100,
      label: t("archive_backend_fs_field_group.high_watermark_label"),
      help: t("archive_backend_fs_field_group.high_watermark_help"),
      required: true,
      labelClassName: "",
      wrapperClassName: ""
    }
  );
};
export default ArchiveBackendFSFieldGroup;
